import {View,Switch} from "vritra";


const SwitchColor={
    name:"SwitchColor",
    type:"object",
    props:[
        {
            name:"true",
            type:"string",
            description:"Color when active",
        },
        {
            name:"false",
            type:"string",
            description:"Color when not active",
        },
    ],
}

export default {
    id:"Switch",
    parent:{name:"View"},
    preview:(props)=>{
        const view=View({
            ...props,
            style:(window.innerWidth<567)&&`
                display:flex;
                justify-content:center;
                align-items:center;
            `,
        });
        Switch({parent:view});
        return view;
    },
    props:[
        {
            name:"active",
            type:"boolean",
            description:"the switch initial value",
        },
        {
            name:"thumbColor",
            type:"string|SwitchColor",
            
        },
        {
            name:"trackColor",
            type:"string|SwitchColor",
            props:[SwitchColor],
        },
        {
            name:"readonly",
            type:"boolean",
            description:"default to false",
        },
        {
            name:"onChange",
            type:"(active:Boolean):void",
        },
    ],
    methods:[
        {
            name:"toggle",
            type:"(active:boolean):void",
            description:`
                sets the switch status. Toggling behavior by default.
                @if readonly is false, onChange is called
            `,
        }
    ],
}
